// extracted by mini-css-extract-plugin
export default {"box":"advertisementSelect_box__NqKBU","box__option":"advertisementSelect_box__option__FKGd1"};